import { mergeAttributes, Node } from "@tiptap/core"

import { selectFirstPanel } from "./tabs-extension"

declare module "@tiptap/core" {
	interface Commands<ReturnType> {
		codeGroup: {
			insertCodeGroup: (titles?: string[]) => ReturnType
			addCodeGroupBlock: (pos: number, title?: string) => ReturnType
			removeCodeGroupBlock: (pos: number) => ReturnType
		}
	}
}

export const DEFAULT_CODE_GROUP_TITLES = ["Example", "Alternative"]

export const CodeGroupExtension = Node.create({
	name: "codeGroup",
	group: "block",
	content: "codeBlock+",
	defining: true,
	isolating: true,

	parseHTML() {
		return [{ tag: 'div[data-type="code-group"]' }]
	},

	renderHTML({ HTMLAttributes }) {
		return [
			"div",
			mergeAttributes(HTMLAttributes, {
				"data-type": "code-group",
				"data-panel-group": "code-group",
				"data-active": "1",
			}),
			0,
		]
	},

	addCommands() {
		return {
			insertCodeGroup:
				(titles = DEFAULT_CODE_GROUP_TITLES) =>
				({ chain, state }) => {
					const from = state.selection.from
					return chain()
						.insertContent({
							type: this.name,
							content: titles.map((title) => ({
								type: "codeBlock",
								attrs: { title },
							})),
						})
						.command((props) => selectFirstPanel(props, this.name, from))
						.run()
				},

			addCodeGroupBlock:
				(pos, title = "New file") =>
				({ tr, state, dispatch }) => {
					const group = state.doc.nodeAt(pos)
					if (group?.type.name !== this.name) return false
					const block = state.schema.nodes.codeBlock?.createAndFill({ title })
					if (!block) return false
					if (dispatch) tr.insert(pos + group.nodeSize - 1, block)
					return true
				},

			removeCodeGroupBlock:
				(pos) =>
				({ tr, state, dispatch }) => {
					const block = state.doc.nodeAt(pos)
					if (block?.type.name !== "codeBlock") return false
					const parent = state.doc.resolve(pos).parent
					if (parent.type.name === this.name && parent.childCount <= 1) {
						return false
					}
					if (dispatch) tr.delete(pos, pos + block.nodeSize)
					return true
				},
		}
	},
})
